import React from 'react';
import { StyleSheet, Text, Pressable } from 'react-native';
import Theme from 'Theme';
import PropTypes from 'prop-types';

const styles = StyleSheet.create({
    link: {
        alignSelf: 'stretch',
        alignItems: 'center',
        justifyContent: 'center'
    },
    buttonText: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryLinkColor,
        fontSize: 20
    }
});

class Link extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { style, onPress, label, testID } = this.props;

        return (
            <Pressable
                style={[styles.link, style]}
                onPress={() => {
                    if (onPress) {
                        onPress();
                    }
                }}
                testID={testID}
            >
                <Text
                    style={[
                        styles.buttonText,
                        {
                            color: style?.color ? style.color : Theme.primaryLinkColor,
                            fontSize: style?.fontSize ? style.fontSize : styles.buttonText.fontSize
                        }
                    ]}
                >
                    {label}
                </Text>
            </Pressable>
        );
    }
}

Link.propTypes = {
    style: PropTypes.shape({}),
    onPress: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    testID: PropTypes.string
};

Link.defaultProps = {
    style: {},
    testID: undefined
};

export default Link;
